import React from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import styles from './ShopPage.module.css';

export default function ShopPage() {
  const { cartItems, addToCart, removeFromCart } = useCart();
  const navigate = useNavigate();
  const total = cartItems.reduce((sum, item) => sum + item.price, 0).toFixed(2);

  return (
    <div className={styles.shopContainer}>
      <h1>ChronoTech Robotics Shop</h1>
      <p className={styles.description}>
        Browse our complete collection of classes and robots. 
        We have a wide variety of new courses and innovative 
        robotic companions currently being developed. Stay tuned!
      </p>

      {/* Class Kit Card */}
      <div className={styles.shopItems}>
        <div className={styles.shopItem}>
          <img src="/images/roboclass.png" alt="Robo Kids classes and kit" className={styles.shopImage} />
          <p className={styles.imageCaption}>Kit styles may vary</p>
          <div className={styles.shopDetails}>
            <h3>Robo Kids: All Class Levels</h3>
            <p className={styles.price}>From $400</p>
            <p>Beginner to advanced classes with live sessions and kits shipped to your home.</p>
     <button
  className={styles.subscribeBtn}
  onClick={() => navigate('/robokidslanding')}
>
  View Classes
</button>

          </div>
        </div>

        {/* AI Teddy Bear */}
        <div className={styles.shopItem}>
          <img src="/images/aiteddy.png" alt="AI Teddy Bear" className={styles.shopImage} />
          <div className={styles.shopDetails}>
            <h3>AI Teddy Bear Companion</h3>
            <p className={styles.price}>$150.00</p>
            <p className={styles.comingSoon}>Coming Soon – Smart emotional companion for kids</p>
          </div>
        </div>

        {/* Spider Robot */}
        <div className={styles.shopItem}>
          <img src="/images/kit-closeup.png" alt="Robot Spider" className={styles.shopImage} />
          <div className={styles.shopDetails}>
            <h3>Robot Spider</h3>
            <p className={styles.price}>$300</p>
            <p className={styles.comingSoon}>The spider robot is undergoing final production. Stay tuned!</p>
          </div>
        </div>
      </div>

      {/* Cart Section */}
      <hr className={styles.divider} />
      <h2>Your Cart</h2>
      <ul className={styles.cartList}>
        {cartItems.length === 0 ? (
          <p>Your cart is currently empty.</p>
        ) : (
          cartItems.map((item, index) => (
            <li key={index} className={styles.cartItem}>
              {item.name} - ${item.price.toFixed(2)}
              <button onClick={() => removeFromCart(item.id)} className={styles.removeBtn}>Remove</button>
            </li>
          ))
        )}
      </ul>
      {cartItems.length > 0 && <h3>Total: ${total}</h3>}
    </div>
  );
}
